import clsx from 'clsx';
import ModalEditGame from '../../../AdminGame/EditPage/modal-edit-game';
import { useHeaderNavStyles } from './HeaderNav.styles';
import { redesignTheme } from '../../theme';

type NavItem = {
  label: string;
  tabIndex: number;
};

type HeaderNavProps = {
  navItems: NavItem[];
  activeTab: number;
  onNavClick: (tabIndex: number) => void;
  isAdmin: boolean;
  openExit: boolean;
  onExitCancel: () => void;
  onExitClose: () => void;
  onExitConfirm: () => void;
};

const HeaderNav = ({
  navItems,
  activeTab,
  onNavClick,
  isAdmin,
  openExit,
  onExitCancel,
  onExitClose,
  onExitConfirm,
}: HeaderNavProps) => {
  const navCollapseAt = isAdmin
    ? redesignTheme.breakpoints.adminDesktop
    : redesignTheme.breakpoints.desktop;
  const classes = useHeaderNavStyles({ navCollapseAt });

  return (
    <>
      {isAdmin && (
        <ModalEditGame
          open={openExit}
          title=""
          handleClose={onExitClose}
          message={`Êtes-vous sûr de vouloir quitter l'édition ${
            !sessionStorage.getItem('book') ? 'du jeu' : 'du book'
          } ?`}
          onCancel={onExitCancel}
          onConfirm={onExitConfirm}
        />
      )}

      <nav className={classes.nav} aria-label="Navigation principale">
        {navItems.map(item => (
          <button
            key={item.tabIndex}
            type="button"
            className={clsx(classes.navItem, activeTab === item.tabIndex && classes.navItemActive)}
            onClick={() => onNavClick(item.tabIndex)}
            aria-current={activeTab === item.tabIndex ? 'page' : undefined}>
            {item.label}
          </button>
        ))}
      </nav>
    </>
  );
};

export default HeaderNav;
